import type { CatalogEntry } from '../types';

/** Analytics (feature `11`) error codes + catalog. Populated in Phase 3. */
export const ANALYTICS_CODES = {} as const;
export const ANALYTICS_CATALOG: Record<string, CatalogEntry> = {};
